import { useCallback, useEffect, useState } from 'react';

export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return fetch('/.netlify/functions/categories-public')
      .then((r) => {
        if (!r.ok) throw new Error('Failed to load categories');
        return r.json();
      })
      .then((data) => setCategories(data.categories || []))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { categories, loading, error, reload: load };
}
